import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../types/Cashier';
import ComposedBonusMessage from '../ComposedBonusMessage/ComposedBonusMessage';
import SeeDetailsLink from '../SeeDetailsLink/SeeDetailsLink';

import {
  TXTCLI_You_are_eligible_for_a_bonus_o_ELL,
  TXTCLI_You_may_only_make_one_deposit__ELL,
  TXTCLI_Your_current_maximum_available_ELL
} from './DefaultBonusMessage.messages.json';

const DefaultBonusMessage: React.FC = () => {
  const {
    data: { preCashinInfo },
    values: {
      deposit: { currency }
    }
  } = useWizardContext();

  const {
    balanceAmount,
    bonusCurrency,
    bonusMax,
    bonusPercent,
    potentialBonusAmount,
    maxPossibleCashInAmount
  } = preCashinInfo as PreCashinInfo;

  const isBonusOverMaxBonus = (maxPossibleCashInAmount * bonusPercent) / 100.0 >= bonusMax;

  return (
    <>
      <ComposedBonusMessage amount={balanceAmount} bonus={potentialBonusAmount} isFirst={false} />
      <SeeDetailsLink />
      <Translation
        tagName="p"
        {...(isBonusOverMaxBonus
          ? TXTCLI_You_are_eligible_for_a_bonus_o_ELL
          : TXTCLI_Your_current_maximum_available_ELL)}
        values={{
          0: (
            <CurrencyAmount
              value={isBonusOverMaxBonus ? bonusMax : maxPossibleCashInAmount}
              currency={bonusCurrency}
            />
          ),
          1: (
            <CurrencyAmount
              value={bonusPercent ? (bonusMax * 100) / bonusPercent : 0}
              currency={currency}
            />
          )
        }}
      />{' '}
      <Translation tagName="p" {...TXTCLI_You_may_only_make_one_deposit__ELL} />
    </>
  );
};

export default DefaultBonusMessage;
